const SnackbarContent = {
  root: {
    // backgroundColor: ninja.getShade(9),
    // boxShadow: shadows[10],
  },
}

export default SnackbarContent

